"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetFacets = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
/* istanbul ignore file -- api */ const useGetFacets = (param)=>{
    let { getFacets, facets } = param;
    const { graphQlNetUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet'
    ]);
    const { headers, loading } = (0, _presentationHttp.useHeaders)();
    const { data, isValidating, error } = (0, _fetching.useSWR)(loading || !facets.length ? null : [
        facets,
        headers,
        graphQlNetUrl
    ], async ()=>getFacets(facets), (0, _presentationUtils.getRetryErrorSwrOptions)());
    const result = (0, _react.useMemo)(()=>({
            isValidating,
            isError: !!error,
            data
        }), [
        data,
        error,
        isValidating
    ]);
    return result;
};
exports.useGetFacets = useGetFacets;
